import { useTimeFrames } from '@/api/time-frames';
import { CreateRestrictionRequestDto } from '@/services/dto/restrictions/create-restriction-input.dto';
import { UpdateRestrictionRequestDto } from '@/services/dto/restrictions/update-restriction-input.dto';
import { useRestrictionsForm } from '@/hooks/restrictions/useRestrictionsForm';
import { useFormContext } from 'react-hook-form';
import {
  AutocompleteMenuSelector,
  ErrorChip,
  FormGroup,
} from '@starsoft/common/components';
import useTranslation from 'next-translate/useTranslation';
import { TimeFrame } from '@/models/time-frame';

export default function RestricitonsModalContentFrameSelector() {
  const { t } = useTranslation('account');
  const { setValue, watch } = useFormContext<
    CreateRestrictionRequestDto & UpdateRestrictionRequestDto
  >();
  const {
    useRestrictionByIdQuery: { isLoadingRestriction },
  } = useRestrictionsForm();
  const {
    timeFrames,
    isPending,
    error,
    refetch,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
  } = useTimeFrames();

  const frame = watch('frameId');

  function handleSelect(option: TimeFrame) {
    setValue('frameId', option.id);
  }

  if (error) {
    return <ErrorChip action={refetch} />;
  }

  return (
    <FormGroup
      label={t('restriction_frame_label') as string}
      isLoading={isLoadingRestriction || isPending}
      loading={{ label: true, secondary: true }}
    >
      <AutocompleteMenuSelector
        options={timeFrames}
        filterBy={['name']}
        setValue={handleSelect}
        value={frame}
        getOptionLabel={e => t(`${e?.id}_frame_label`)}
        getOptionValue={e => e?.id}
        loading={isPending || isLoadingRestriction}
        loadMore={fetchNextPage}
        hasNextPage={hasNextPage}
        hideSearch
        loadingMore={isFetchingNextPage}
        title={t('restriction_frame_label') as string}
      />
    </FormGroup>
  );
}
